export var RenderStateType;
(function (RenderStateType) {
    RenderStateType[RenderStateType["DepthTest"] = 0] = "DepthTest";
    RenderStateType[RenderStateType["DepthMask"] = 1] = "DepthMask";
    RenderStateType[RenderStateType["DepthFunc"] = 2] = "DepthFunc";
    RenderStateType[RenderStateType["StencilTest"] = 3] = "StencilTest";
    RenderStateType[RenderStateType["StencilMask"] = 4] = "StencilMask";
    RenderStateType[RenderStateType["StencilFunc"] = 5] = "StencilFunc";
    RenderStateType[RenderStateType["StencilOp"] = 6] = "StencilOp";
    RenderStateType[RenderStateType["BlendType"] = 7] = "BlendType";
    RenderStateType[RenderStateType["BlendEquation"] = 8] = "BlendEquation";
    RenderStateType[RenderStateType["BlendEquationSeparate"] = 9] = "BlendEquationSeparate";
    RenderStateType[RenderStateType["BlendFunc"] = 10] = "BlendFunc";
    RenderStateType[RenderStateType["BlendFuncSeperate"] = 11] = "BlendFuncSeperate";
    RenderStateType[RenderStateType["CullFace"] = 12] = "CullFace";
    RenderStateType[RenderStateType["FrontFace"] = 13] = "FrontFace";
})(RenderStateType || (RenderStateType = {}));
